import apiRequest from "../utils/request";
import { RequestPayload as UpdateSettingsRequestPayload } from "../routes/Settings/utils";
import {
  CustomEventTopic,
  StoreType,
  WebhookTopic,
} from "../routes/Settings/components/types";
import type { BackfillScope } from "../routes/DataBackfill/constants";

interface ValidateApiKeyRequestPayload {
  iterable_api_key: string;
  email: string;
}
interface HistoryBackfill {
  /**
   * date and time in RFC3339 format
   */
  timeFrom?: string;
  scopes: BackfillScope[];
}

export interface SendInstallationDataRequestPayload {
  iterableKey: string;
  email: string;
  historyBackfill: HistoryBackfill;
  storeType: StoreType;
}

export interface SendInstallationDataV2RequestPayload {
  iterable_api_key: string;
  email: string;
  store_type: StoreType;
  history_backfill: {
    time_from?: string;
    scopes: BackfillScope[];
  };
}

export interface UpdateSettingsV2RequestPayload {
  iterable_api_key?: string;
  webhook_event_topics: WebhookTopic[];
  custom_event_topics: CustomEventTopic[];
  is_tracking_catalog: boolean;
  store_type: StoreType;
  resync_catalog_from: string;
}

export const validateApiKey = (shop: string, payload: ValidateApiKeyRequestPayload) => {
  const baseURL = process.env.REACT_APP_CONSOLIDATED_SERVICE_URL;
  
  return apiRequest({
    url: `/merchants/v2/${shop}/validated`,
    method: "post",
    payload,
    config: {
      baseURL: baseURL,
    },
  });
};

// Golang endpoint (traditional stores)
export const sendInstallationData = (
  payload: SendInstallationDataRequestPayload
) =>
  apiRequest({
    url: "/app/installed",
    method: "post",
    payload,
  });

// Scala v2 endpoint (custom stores)
export const sendInstallationDataV2 = (
  shop: string,
  payload: SendInstallationDataV2RequestPayload
) => {
  const baseURL = process.env.REACT_APP_CONSOLIDATED_SERVICE_URL;
  
  return apiRequest({
    url: `/merchants/v2/${shop}/installed`,
    method: "post",
    payload,
    config: {
      baseURL: baseURL,
    },
  });
};

export const getSettings = () => {
    return apiRequest({
    url: "/merchants",
  });
};

export const checkMerchantOnboarded = (shop: string) => {
  const baseURL = process.env.REACT_APP_CONSOLIDATED_SERVICE_URL;
  
  return apiRequest({
    url: `/merchants/v2/${shop}`,
    config: {
      baseURL: baseURL,
    },
  });
};

export const getSettingsV2 = (shop: string) => {
  const baseURL = process.env.REACT_APP_CONSOLIDATED_SERVICE_URL;
  
  return apiRequest({
    url: `/merchants/v2/${shop}/settings`,
    config: {
      baseURL: baseURL,
    },
  });
};

export const updateSettings = (payload: UpdateSettingsRequestPayload) =>
  apiRequest({
    url: "/merchants",
    method: "put",
    payload,
  });

export const updateSettingsV2 = (shop: string, payload: UpdateSettingsV2RequestPayload) => {
  const baseURL = process.env.REACT_APP_CONSOLIDATED_SERVICE_URL;

  return apiRequest({
    url: `/merchants/v2/${shop}/settings`,
    method: "put",
    payload,
    config: {
      baseURL: baseURL,
    },
  });
};
